import { Link } from 'react-router-dom'
import { useState } from 'react'
import './Header.css'

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [openDropdown, setOpenDropdown] = useState<null | 'services' | 'sectors'>(null)

  const closeMenu = () => {
    setIsMenuOpen(false)
    setOpenDropdown(null)
  }

  const toggleServices = () => {
    setOpenDropdown((d) => (d === 'services' ? null : 'services'))
  }

  const toggleSectors = () => {
    setOpenDropdown((d) => (d === 'sectors' ? null : 'sectors'))
  }

  return (
    <header>
      <div className="logo">
        <Link to="/">
          <img src="/Adept Service LOGO File.png" alt="Adept Group" className="logo-image" />
          <strong>Adept GROUP</strong>
        </Link>
      </div>
      <input 
        id="nav-toggle" 
        type="checkbox" 
        className="nav-toggle" 
        checked={isMenuOpen}
        onChange={(e) => setIsMenuOpen(e.target.checked)}
      />
      <label htmlFor="nav-toggle" className="hamburger" aria-label="Toggle navigation">
        <span></span>
        <span></span>
        <span></span>
      </label>
      <div className="header-actions">
        <nav>
          <ul>
            <li><Link to="/about" onClick={closeMenu}>About</Link></li>
            <li className={`has-dropdown ${openDropdown === 'services' ? 'open' : ''}`}>
              <span onClick={toggleServices} aria-expanded={openDropdown === 'services'} role="button">Our Services</span>
              <ul className="dropdown-menu">
                <li><Link to="/services/commercial-cleaning" onClick={closeMenu}>Commercial Cleaning</Link></li>
                <li><Link to="/services/specialized-cleaning" onClick={closeMenu}>Specialised Cleaning</Link></li>
                <li><Link to="/services/hygiene-services" onClick={closeMenu}>Hygiene Services</Link></li>
                <li><Link to="/services/consumable-services" onClick={closeMenu}>Consumable Services</Link></li>
              </ul>
            </li>
            <li className={`has-dropdown ${openDropdown === 'sectors' ? 'open' : ''}`}>
              <span onClick={toggleSectors} aria-expanded={openDropdown === 'sectors'} role="button">Sectors We Serve</span>
              <ul className="dropdown-menu">
                <li><Link to="/sectors/commercial-industrial" onClick={closeMenu}>Commercial & Industrial</Link></li>
                <li><Link to="/sectors/hospitality" onClick={closeMenu}>Hospitality & Leisure</Link></li>
                <li><Link to="/sectors/education-and-institutions" onClick={closeMenu}>Education Campuses</Link></li>
                <li><Link to="/sectors/aged-care-healthcare" onClick={closeMenu}>Healthcare Facilities</Link></li>
                <li><Link to="/sectors/technology-data-centres" onClick={closeMenu}>Data Centers & Technology Spaces</Link></li>
                <li><Link to="/sectors/government-public" onClick={closeMenu}>Government & Infrastructure</Link></li>
              </ul>
            </li>
            <li><Link to="/esg" onClick={closeMenu}>ESG</Link></li>
            <li><Link to="/careers" onClick={closeMenu}>Careers</Link></li>
            <li><Link to="/contact" onClick={closeMenu}>Contact Us</Link></li>
          </ul>
        </nav>
        <a href="https://www.linkedin.com/company/adept-services-pty-ltd/" target="_blank" rel="noopener noreferrer" className="linkedin-icon">
          <img src="/icons/LinkedIn_logo_initials.png" alt="LinkedIn" />
        </a>
        <Link className="cta-button" to="/contact" onClick={closeMenu}>Get Quote</Link>
      </div>
    </header>
  )
}

export default Header
